module.exports = new __parcel__URL__("faq_content_zh-cn.a854a9b3.webp").toString();